<div class="dsm-flex-container horizontal-card {{componentStyle}}" [ngStyle]="{'background-color': backgroundColor}">
    <div class="panel">
        <div class="panel-body flex-row">
            <div class="flex-col image-col">
                <img src="{{mobileImagePath}}" class="img-fluid" alt=""/>
            </div>
            <div class='panel-text-wrapper flex-col'>
                <p class="heading-2">{{translationRoot + '.body' | translate:useLocaleOverride}}</p>
                <button *ngIf="componentData.includeCallToAction" type="button"
                        class="button button-large {{buttonType}}" (click)="callToActionClick()">
                    {{translationRoot + '.button' | translate:useLocaleOverride}}
                </button>
            </div>
        </div>
    </div>
</div>
